import { FC } from 'react'
import { useSearchResultListingHead } from './hooks'
import Page from '../../common/page'

const SearchResultListingHead: FC = () => {
    const { head } = useSearchResultListingHead()
    if (!head) {
        return null
    }

    return <Page head={head} />
}

export default SearchResultListingHead
